export const MarketingTypes = {
  MARKETING: 'marketing',
  SYSTEM: 'system',
};
